import usePlans from 'hooks/usePlans';
import useRecommendations from 'hooks/useRecommendations';
import useApplications from '../../../../screens/Applications&WorkOrders/Applications/Hooks/useApplications';
import useInvoiceData from '../../../../screens/Invoices/helpers/useInvoiceData';

const LoadRecs = () => {
  const { recommendations, isLoading: recsLoading } = useRecommendations();
  return { recommendations, recsLoading };
};

const LoadInvoices = () => {
  const { invoices, loading: invLoading } = useInvoiceData();
  return { invoices, invLoading };
};

const LoadApplications = () => {
  const { applications, loading: applicationsLoading } = useApplications();
  return { applications, applicationsLoading };
};

const LoadPlans = () => {
  const { plans, isLoading: plansLoading } = usePlans();
  return { plans, plansLoading };
};

const useSources = () => {
  const { plans, plansLoading } = LoadPlans();
  const { applications, applicationsLoading } = LoadApplications();
  const { invoices, invLoading } = LoadInvoices();
  const { recommendations, recsLoading } = LoadRecs();

  const isLoading =
    plansLoading || applicationsLoading || invLoading || recsLoading;

  return { plans, applications, invoices, recommendations, isLoading };
};

export default useSources;
